import { fetchTrafficUsed } from "@fd/common/api/fetchTraffic";
import { AllTrafficUsedType } from "@fd/common/biz/traffic";
import { useSubscriptions } from "./useSubscriptions";
import useSWR from "swr";

export const useAllTrafficUsed = (): AllTrafficUsedType | undefined => {
  const subscriptions = useSubscriptions();

  const { data: allTrafficUsed } = useSWR(
    subscriptions.length > 0 ? ["trafficUsed", subscriptions] : null,
    ([, subscriptions]) => fetchTrafficUsed(subscriptions),
  );

  return allTrafficUsed;
};
